import styles from '@/components/ui/buttons/CategoryBadgeComponent.module.css'
import { useEffect, useState } from 'react'

function CategoryBadgeComponent({ text, count }) {
  const [gap, setGap] = useState(-256) // Default height of the fixed header

  /*const handleClick = () => {
    const categoryElement = document.getElementById(`category-${text}`);
    if (categoryElement) {
      categoryElement.scrollIntoView({ behavior: 'smooth' });
    }
  };*/

  useEffect(() => {
    const updateColumns = () => {
      const width = window.innerWidth
      if (width <= 480) {
        setGap(-330)
      } else if (width <= 768) {
        setGap(-288)
      } else {
        setGap(-256)
      }
    }

    updateColumns() // Initial check
    window.addEventListener('resize', updateColumns)
    return () => window.removeEventListener('resize', updateColumns)
  }, [])

  const handleClick = () => {
    const categoryElement = document.getElementById(`category-${text}`)
    if (categoryElement) {
      categoryElement.scrollIntoView({ behavior: 'smooth' })
      // Adjust for the fixed header
      setTimeout(() => {
        const yOffset = gap // Height of the fixed header
        const y = categoryElement.getBoundingClientRect().top + window.pageYOffset + yOffset
        window.scrollTo({ top: y, behavior: 'smooth' })
      }, 300) // Delay to ensure the initial scrollIntoView is completed
    }
  }

  return (
    <div className={styles.cw_category__badge} onClick={handleClick}>
      <span className={styles.category}>{text}</span>
      <span className={styles.count}>{count}</span>
    </div>
  )
}

export default CategoryBadgeComponent
